import _round from 'lodash-es/round';
import { redToGreenGradientContrasted } from './redToGreenGradientContrasted';

export function getContrastBasedOnValue(value: number) {
  const indexGradient = _round(
    ((redToGreenGradientContrasted.length - 1) * value) / 100,
  );
  return redToGreenGradientContrasted[indexGradient];
}
